module.exports = __webpack_public_path__ + "img/chahua.6bcfe7aa.png";